'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="it">
      <body>
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2>Si è verificato un errore imprevisto</h2>
          <p style={{ color: '#666' }}>L&apos;errore è stato registrato automaticamente.</p>
          <button
            onClick={reset}
            style={{ marginTop: '1rem', padding: '0.5rem 1.5rem', cursor: 'pointer' }}
          >
            Riprova
          </button>
        </div>
      </body>
    </html>
  )
}
